import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DashboardServicesService } from '../_services/dashboard-services.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private inject: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authService = this.inject.get<DashboardServicesService>(
      DashboardServicesService
    );
    let token = request;
    token = this.addTokenHeader(request, authService.getToken());
    return next.handle(token).pipe(
      catchError((errorData) => {
        if (errorData.status === 401) {
          authService.logOut();
        }
        return throwError(errorData);
      })
    );
  }

  addTokenHeader(request: HttpRequest<any>, token: any) {
    return request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + token),
    });
  }
}
